/**
 * @typedef {import('./lib/index.js').Schema} Schema
 */

export {sanitize} from './lib/index.js'
export {defaultSchema} from './lib/schema.js'
